import * as pbi from 'powerbi-client';

const PowerBIHelper = {
    getService: function() {
        if (window['powerbi'] === null || window['powerbi'] === undefined) {
            window['powerbi'] = new pbi.service.Service(
                pbi.factories.hpmFactory,
                pbi.factories.wpmpFactory,
                pbi.factories.routerFactory);
        }
        return window['powerbi'];
    }
}
export default PowerBIHelper;



// WEBPACK FOOTER //
// ./src/Components/_Shared/PowerBiHelper.js